package uz.ferro.erp.feature.text.model

import kotlinx.serialization.Serializable

@Serializable
data class DocItem(
    val type: DocItemType,
    val style: TextStyle? = null,
    val text: String? = null,
    val textItems: List<TextItem>? = null,
    val listItems: List<DocContent>? = null,
    val listStyle: ListStyle? = null,
    val href: String? = null,
    val isNewLine: Boolean? = null,
    val source: String? = null,
    val width: String? = null,
    val height: String? = null,
    val maxWidth: String? = null,
    val maxHeight: String? = null

)
